import './Divider.css';

const Divider = () => {
  return (
    <hr className='rntr-divider'/>
  );
}

export default Divider;